import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import {TermsOfUseModel} from './model/terms-of-use.model';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-terms-of-use',
    templateUrl: './terms-of-use.component.html',
    styles: [],
    providers: [TermsOfUseModel],
    standalone: true,
    imports: [DatePipe]
})
export class TermsOfUseComponent implements OnInit {
  @ViewChild('whowe', { static: true }) private whoweContainer: ElementRef;
  @ViewChild('scope', { static: true }) private scopeContainer: ElementRef;
  @ViewChild('infowecollect', { static: true }) private infowecollectContainer: ElementRef;
  @ViewChild('personalinfo', { static: true }) private personalinfoContainer: ElementRef;
  @ViewChild('sharepersonalinfo', { static: true }) private sharepersonalinfoContainer: ElementRef;
  @ViewChild('security', { static: true }) private securityContainer: ElementRef;
  @ViewChild('otherweb', { static: true }) private otherwebContainer: ElementRef;
  @ViewChild('internetbased', { static: true }) private internetbasedeContainer: ElementRef;
  @ViewChild('changes', { static: true }) private changesContainer: ElementRef;
  @ViewChild('contactus', { static: true }) private contactusContainer: ElementRef;
  @ViewChild('infowhich', { static: true }) private infowhichContainer: ElementRef;
  @ViewChild('legal', { static: true }) private legalContainer: ElementRef;
  @ViewChild('howlong', { static: true }) private howlongContainer: ElementRef;
  @ViewChild('yourrights', { static: true }) private yourrightsContainer: ElementRef;
  @ViewChild('internationaldata', { static: true }) private internationaldataContainer: ElementRef;
  @ViewChild('complaints', { static: true }) private complaintsContainer: ElementRef;
  @ViewChild('cookie', { static: true }) private cookieContainer: ElementRef;

  constructor(public model: TermsOfUseModel) { }

  ngOnInit() {
    this.model.initModel();
  }

  clickcookie() {
    try {
      this.cookieContainer.nativeElement.scrollIntoView(false);
    } catch (err) { }
  }

  clickwhowe() {
    try {
      this.whoweContainer.nativeElement.scrollIntoView(false);
    } catch (err) { }   
  }

  clickscope() {
    try {
      this.scopeContainer.nativeElement.scrollIntoView(false);
    } catch (err) { }   
  }

  clickinfowecollect() {
    try {
      this.infowecollectContainer.nativeElement.scrollIntoView(false);
    } catch (err) { }   
  }

  clickpersonalinfo() {
    try {
      this.personalinfoContainer.nativeElement.scrollIntoView(false);
    } catch (err) { }   
  }

  clicksharepersonalinfo() {
    try {
      this.sharepersonalinfoContainer.nativeElement.scrollIntoView(false);
    } catch (err) { }   
  }

  clicksecurity() {
    try {
      this.securityContainer.nativeElement.scrollIntoView(false);
    } catch (err) { }   
  }

  clickotherweb() {
    try {
      this.otherwebContainer.nativeElement.scrollIntoView(false);
    } catch (err) { }   
  }

  clickinternetbased() {
    try {
      this.internetbasedeContainer.nativeElement.scrollIntoView(false);
    } catch (err) { }   
  }

  clickchanges() {
    try {
      this.changesContainer.nativeElement.scrollIntoView(false);
    } catch (err) { }   
  }

  clickcontactus() {
    try {
      this.contactusContainer.nativeElement.scrollIntoView(false);
    } catch (err) { }   
  }

  clickinfowhich() {
    try {
      this.infowhichContainer.nativeElement.scrollIntoView(false);
    } catch (err) { }   
  }

  clicklegal() {
    try {
      this.legalContainer.nativeElement.scrollIntoView(false);
    } catch (err) { }   
  }

  clickhowlong() {
    try {
      this.howlongContainer.nativeElement.scrollIntoView(false);
    } catch (err) { }   
  }

  clickyourrights() {
    try {
      this.yourrightsContainer.nativeElement.scrollIntoView(false);
    } catch (err) { }   
  }

  clickinternationaldata() {
    try {
      this.internationaldataContainer.nativeElement.scrollIntoView(false);
    } catch (err) { }   
  }

  clickcomplaints() {
    try {
      this.complaintsContainer.nativeElement.scrollIntoView(false);
    } catch (err) { }   
  }

}
